import React from "react";
import Content from "../../componenets/Content";

const Home = () => {
  return (
    <>
      <Content />
    </>
  );
};

export default Home;
